





























































import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'NavBar',
  components: {}
})
export default class extends Vue {
  permanent = true
  logoBlack = require('../assets/logo.png')
  logoWhite = require('../assets/logowhite.png')
  //color = 'blue-grey darken-4'
  color = '#2b3549'
  shop = {
    name: 'Administration',
    version: 'Version 0.1.0'
  }
}
